import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import MemberGloData from 'lowcode/utils/MemberGloData';
import type { GetServerSidePropsContext, NextPage } from 'next';
import * as LowcompMember from 'lowcomp/plugins/member/indexS';
import * as LowcompIndex from 'lowcomp/plugins/index-series/indexS';
import { EcoProvider } from 'lowcode/utils/context/ecocredits';
import { queryEditorOnline } from 'lowcode/utils/service';
import Product from 'lowcode/pages/product';
// import MonthlyCompoment from '@/components/EcocreditsMonthlyMadness';
// import { MonthlyProvider } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { IPageStatus } from '@/components/EcocreditsMonthlyMadness/type';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/appreciation-day';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import efBridge from '@/utils/JSBridge';
import { onLogin } from '@/utils/cookie';
import './index.scss';
import { getAppSession } from '@/utils/appGetToken';

export interface PageProps {
    isLogin: boolean;
    SEO: any;
    debug: IPageStatus;
    ecocreditsData: { [key: string]: string | number | boolean | null };
    status: IPageStatus | null;
}

const allTemp = {
    ...LowcompIndex,
    ...LowcompMember,
};

// AppreciationDay
const EcocreditsAppreciationWeek: NextPage<PageProps> = ({ isLogin, SEO, id, data }: any) => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecocredits');
    const router = useRouter();
    const { locale } = router;

    const { isApp } = useGlobal();

    if (isApp) {
        // efBridge.registerHandler('getAppMsg', (res) => {
        //     if (!res) return;
        //     const dataSet = {
        //         token: res.token.replace('Bearer ', ''),
        //         user: {},
        //     };
        //     onLogin(dataSet);
        // });
        const token = getAppSession();
        const dataSet = {
            token,
            user: {},
        };
        onLogin(dataSet);
    }
    // const initState = {
    //     isLogin: isApp ? true : isLogin,
    //     timeLine: ecocreditsData.timeLine,
    //     protocol: ecocreditsData.protocol,
    //     pageStatus: status || IPageStatus.TEASER,
    // };

    // const isDebug = debug && Object.values(IPageStatus).includes(debug);

    // if (isDebug) {
    //     initState.pageStatus = debug;
    // }

    // const IS_PROD: boolean = process.env.NEXT_PUBLIC_MODY === 'prd';
    // const IS_FIX_SITES: boolean = [''].includes(locale);

    return (
        <>
            <SEO title={t('seo.title') || t('join_title')} description={t('seo.desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2132;
                    }
                    .glo-editor-modal-show {
                        z-index: 2133;
                    }
                `}
            </style>
            <PageLayout isNoFixed>
                <MemberTimeProvider>
                    <MemberGloData isOpenA={true} />
                    <EcoProvider>
                        <Product id={id} data={data} allTemp={allTemp} />
                    </EcoProvider>
                </MemberTimeProvider>
            </PageLayout>
        </>
    );
};

export default EcocreditsAppreciationWeek;

// za站要这个路由，没得办法复制了一份出来
export async function getServerSideProps({ locale, req, query }: GetServerSidePropsContext) {
    const whiteLocaleList = ['za', 'au'];
    const time = new Date().getTime();
    // 包含 timeLine
    // let ecocreditsData = null;
    // try {
    //     ecocreditsData = require(`@/data/ecocredits/${locale}.js`);
    // } catch (err) {
    //     ecocreditsData = require(`@/data/ecocredits/index.js`);
    //     throw new Error('读取/data/ecocredits/index.js失败');
    // }
    // const { timeLine, protocol } = ecocreditsData;
    // const { debug } = query;
    // 时间节点判断
    // let isTeaser = false;
    // let isActivity = false;
    // if (time >= timeLine.teaser.start && time < timeLine.teaser.end) isTeaser = true;
    // if (time >= timeLine.activity.start && time < timeLine.activity.end) isActivity = true;
    // 测试
    // isActivity = true;
    // isTeaser = true;

    // 当前阶段
    // let status: IPageStatus | null = IPageStatus.TEASER;
    // if (ecocreditsData.timeLine) {
    //     if (time < ecocreditsData.timeLine.teaser.start) {
    //         status = null;
    //     } else if (time < ecocreditsData.timeLine.teaser.end) {
    //         status = IPageStatus.TEASER;
    //     } else if (time < ecocreditsData.timeLine.activity.end) {
    //         status = IPageStatus.ACTIVITY;
    //     } else {
    //         status = null;
    //     }
    // }

    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }

    // 结束后重定向到 ecocredits页面 (不是预热也不是活动阶段), 产品说去掉，配合配置化页面
    // if (!status && !debug) {
    //     return {
    //         redirect: {
    //             destination: `/${locale}/ecocredits`,
    //             permanent: true,
    //         },
    //     };
    // }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    // 配置化
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    const id = 'ecocredits-appreciation-week';
    try {
        data = await queryEditorOnline(id, locale as string);
    } catch (e: any) {}

    // if (locale === 'za' && status === IPageStatus.ACTIVITY) {
    //     return {
    //         redirect: {
    //             destination: 'https://za.ecoflow.com/pages/ecocredits-appreciation-week',
    //             permanent: true,
    //         },
    //     };
    // }

    return {
        props: {
            isLogin,
            // isActivity,
            // isTeaser,
            // protocol,
            // ecocreditsData,
            // status,
            // debug: debug || '',
            id,
            data,
        },
    };
}
